import styled from "styled-components";

export const TpayButton = styled.button<{ isLoading?: boolean; }>`
    border: 2px solid #FFDD2D;
    text-align: center;
    color: #333333;
    background-color: #FFDD2D;
    height: 70px;
    width: 100%;
    border-radius: 12px;
    font-size: 20px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    ${p => p.isLoading && `
        pointer-events: none;
        opacity: 0.6;
    `}
`;
